module.exports = __webpack_public_path__ + "static/Intello-7778ddd497569b934ec886ad8b7b06a1.jpg";